package com.fireavert.analytics.client.presentation

import com.fireavert.common.ViewModel

class AppViewModel: ViewModel() {
    val scope = viewModelScope
}
